<template>
  <div>
    <bread-cump :cumps="$route.meta.breadcrumps" :params="$route.params" />
    <v-container fluid>
      <v-row justify="center">
        <v-col lg="12">
          <v-card class="card--shadow">
            <list :counselingData="counselingData" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import List from "@/components/counseling/List";
import { mapState } from "vuex";
import BreadCump from "@/components/navigation/BreadCump";
export default {
  components: {
    List,
    BreadCump,
  },
  computed: {
    ...mapState("Counseling", ["counselingData"]),
  },
  created() {
    const param = {
      month: this.$route.params.month,
      year: this.$route.params.year,
    };
    if (this.$route.query.township)
      param.township_id = this.$route.query.township;
    this.$store.dispatch("Counseling/getAll", param);
  },
};
</script>
